import React, { useEffect, useState } from 'react'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { StaticQuery } from 'gatsby';
import { graphql } from 'gatsby';
import { getImage } from '../utils';
import showdown from 'showdown';
import Truncate from 'react-truncate';
const converter = new showdown.Converter()

const Item = ({
    image,
    name,
    position,
    desc
}) => {
    return (
        <div
            style={{
                borderRadius: "0 0 1rem 1rem"
            }}
            className="bg-white d-flex flex-column align-items-center px-3 py-5">
            <img
                src={image.image}
                alt={image.alt}
                style={{ width: "120px", color: "black" }} />
            <div className="text-muted py-3" style={{ height: "150px" }}>
                {/* <Truncate lines={5} ellipsis={<span>...</span>}> */}
                    <div
                        dangerouslySetInnerHTML={{ __html: converter.makeHtml(desc) }} />
                {/* </Truncate> */}
            </div>
            <div className="font-weight-bold mb-1">{name}</div>
            {/* <div className="font-weight-bold text-muted">{position}</div> */}
        </div>
    )
}

const MAX_PER_SLIDE = 3;

const TestimonialsRoll = ({
    data
}) => {
    const [slides, setSlides] = useState([]);
    const [testimonials, setTestimonials] = useState([]);

    useEffect(() => {
        const {
            testimonials: _testimonials
        } = data.markdownRemark.frontmatter;

        const newTestimonials = _testimonials.map(item => ({
            ...item,
            image: {
                ...item.image,
                image: getImage(item.image)
            }
        }))

        let aux = [];
        const len = newTestimonials.length;
        if (len > 0) {
            const count = Math.ceil(len / MAX_PER_SLIDE);
            for (let index = 0; index < count; index++) {
                const prodSet = newTestimonials.slice(index * MAX_PER_SLIDE, (index + 1) * MAX_PER_SLIDE);
                aux.push(prodSet);
            }
        }
        setSlides(aux);
        setTestimonials(newTestimonials);
    }, [data.markdownRemark.frontmatter.testimonials]);

    return (
        <div className="container-fluid position-relative px-0">
            <img
                style={{
                    index: "-1",
                    objectFit: "cover"
                }}
                src="/img/bdz-bg-primary.jpg"
                alt="bg"
                className="h-100 w-100 position-absolute" />
            <div className="container py-5">
                <div
                    className="text-white d-flex flex-column align-items-center">
                    <div
                        style={{
                            borderBottom: "2px solid",
                            zIndex: "100"
                        }}
                        className="font-weight-bold pb-1 mb-3">
                        TESTIMONIOS
                    </div>
                    <h3
                        style={{
                            zIndex: "100"
                        }}
                        className="font-weight-bold mb-5">
                        QUÉ DICE LA GENTE
                    </h3>
                </div>
                {/* displayed in desktop */}
                <div className="d-none d-md-block">
                    <Carousel
                        showStatus={false}
                        showThumbs={false}
                        emulateTouch>
                        {
                            slides.map((slide, index) => (
                                <div
                                    key={`slide-${index}`}
                                    className="row pb-5">
                                    {
                                        slide.map((item, index2) => {
                                            return (
                                                <div
                                                    key={`testt${index2}`}
                                                    className={`col-md-6 col-lg-4 mb-3 mb-lg-0`}>
                                                    <Item {...item} />
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            ))
                        }
                    </Carousel>
                </div>

                {/* displayed in mobile */}
                <div className="d-block d-md-none">
                    <Carousel
                        showStatus={false}
                        showThumbs={false}
                        emulateTouch>
                        {
                            testimonials.map((item, index) => {
                                return (
                                    <div
                                        key={`test${index}`}
                                        className="pb-5"
                                    >
                                        <Item {...item} />
                                    </div>
                                )
                            })
                        }
                    </Carousel>
                </div>
            </div>
        </div>
    )
}

export default props => (
    <StaticQuery
        query={graphql`
            query TestimonialsRoll {
                markdownRemark(frontmatter: { templateKey: { eq: "projects-page" } }) {
                  frontmatter {
                    testimonials {
                        image {
                            image {
                              childImageSharp {
                                  fluid {
                                      ...GatsbyImageSharpFluid
                                  }
                              }
                              publicURL
                            }
                            alt
                        }
                        name
                        position
                        desc
                    }
                  }
                }
              }
          `}
        render={(data, count) => <TestimonialsRoll data={data} {...props} />}
    />
)